var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-start flex-column",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.scrollTo(_vm.link)}}},[_c('div',{staticClass:"rect-button"},[_c('div',{class:_vm.className},[_c('span',{staticClass:"nexaExtraBold"},[_vm._v(_vm._s(this.text))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }